import { type ComponentPropsWithRef, useRef } from 'react';

import { VFlex } from '../VFlex';
import { VTooltip } from '../VTooltip';
import { Info } from '../asset';
import { new__cn as cn } from '../util';
import twStyle from './style';
import type { VLabelProps } from './type';

const VLabel = ({
  children,
  className,
  disabled,
  htmlFor,
  infoTooltipContent,
  labelClassName,
  ref,
  required,
  ...rest
}: VLabelProps & ComponentPropsWithRef<'div'>) => {
  const style = twStyle({ disabled, required });
  const labelRef = useRef<HTMLLabelElement>(null);

  return (
    <VFlex
      ref={ref}
      className={cn(style.container, className)}
      role="presentation"
      gap={0.25}
      style={rest.style}
      items="center"
      data-testid="v-label-container"
    >
      <VFlex
        className="overflow-hidden"
        items="start"
        role="presentation"
        gap={0.25}
      >
        <label
          ref={labelRef}
          className={cn(style.label, labelClassName)}
          htmlFor={htmlFor}
        >
          {children}
        </label>

        {required && (
          <div
            className={style.requiredBullet}
            data-testid="v-label-required-bullet"
            onClick={() => labelRef.current?.click()}
          />
        )}
      </VFlex>

      {infoTooltipContent && (
        <VTooltip content={infoTooltipContent}>
          <Info className="h-3 w-3 min-w-3 text-info-500" />
        </VTooltip>
      )}
    </VFlex>
  );
};

export default VLabel;
